<template>
<div>
  <h2 class="title">{{title!==undefined ? title : "Print the Book of your Blog!"}}</h2>
  <b-field type="is-primary" position="is-centered" :addons="singleLine">
    <b-input class="siteInput" type="text" size="is-large" expanded
             :placeholder="placeholder || 'enter my.blog.site or @myinsta here'"
             @keyup.native.enter="submit()"
             v-model="site"></b-input>
    <p v-if="singleLine" class="control">
      <button class="button is-primary is-large"
              xx:disabled="!canSubmit"
              @click="submit()"
              v-html="buttonLabel"/>
    </p>
  </b-field>
  <b-field v-if="!singleLine" type="is-primary" position="is-centered">
    <p class="control is-pulled-right">
      <button class="button is-primary is-large"
              xx:disabled="!canSubmit"
              @click="submit()"
              v-html="buttonLabel"/>
    </p>
  </b-field>

  <b-modal :active.sync="showIndexer" :canCancel="['escape', 'x']" has-modal-card>
    <index-page :site="site" :tag="location"></index-page>
  </b-modal>  

</div>
</template>

<script>
import IndexPage from '@/components/IndexPage'
import { repairSite } from '@/siteurl.js'

export default {
  name: 'IndexLauncher',
  components: {
    IndexPage,
  },
  data: function() { return {
    site: '',
    buttonLabel: 'Preview my Book',
    showIndexer: false,
    windowWidth: window.innerWidth,
  }},
  props: {
    title: { type: String },
    placeholder: { type: String },
    location: { type: String },
    dropButton: { type:Boolean },
    cms: { type: String },
  },
  computed: {
    canSubmit: function() {
      return this.site && this.$store.state.user
    },
    singleLine: function() {
      return !this.dropButton && this.windowWidth > 600;
    }
  },
  methods: {
    submit: function() {
      if (this.canSubmit) {
        this.site = repairSite(this.site, this.cms)
        this.showIndexer = true
        this.$store.commit('updateSite', this.site)
      }
    },
  },
  beforeMount: function () {
    this.site = this.$store.state.defaultSite    
  },
  mounted: function() {
    this.windowWidth = window.innerWidth
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
    })
  },
}
</script>

<style scoped>
.is-dark h1.title {
    text-shadow: -1px 0px grey, 0px 1px grey, 0px -1px grey, 1px 0px grey;
}
.siteInput {
    opacity: 0.9;
}

.button {
    xbackground: white;
    xcolor: black;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexLauncher.vue